import * as migration from './migration';

export default {
    migration,
};
